module.exports = __webpack_public_path__ + "static/media/plus-icon.6545088a.svg";